import Alimony from '../../cards/alimony';
import { ExpiringVisaContactInfo } from '../../cards/contact-info-short/expiring-visa';
import Disqualifying from '../../cards/disqualifying';
import EarlyKickOut from '../../cards/early-kick-out';
import { LateTaxes } from '../../cards/late-taxes';
import Visa from '../../cards/visa';
import { Branch, Card } from '../../components/deck';

export default (continuation) =>
  Card(
    Disqualifying,
    Branch(
      {
        LateTaxes: Card(LateTaxes)
      },
      ({ model }) => {
        // Allow Veterans through regardless of late taxes
        const veteranStatus = model.getIn(['borrower', 'vaQualification']);
        const coborrowerVeteranStatus = model.getIn(['coborrower', 'vaQualification']);
        const hasVeteranStatus =
          (veteranStatus && veteranStatus !== 'Ineligible') ||
          (coborrowerVeteranStatus && coborrowerVeteranStatus !== 'Ineligible');
        if (hasVeteranStatus) {
          return null;
        }
        const hasAdvisorReferral = model.getIn(['loan', 'advisor']);
        if (hasAdvisorReferral) {
          return null;
        }
        const taxesFiledOnTime = model.getIn(['loan', 'taxesFiled']);
        return taxesFiledOnTime ? null : 'LateTaxes';
      },
      Branch(
        {
          NonCitizen: Card(
            Visa,
            Branch(
              {
                ExpiringVisa: Card(ExpiringVisaContactInfo, Card(EarlyKickOut))
              },
              ({ model }) => {
                // Allow Veterans through regardless of expiring Visa
                const veteranStatus = model.getIn(['borrower', 'vaQualification']);
                const coborrowerVeteranStatus = model.getIn(['coborrower', 'vaQualification']);
                const hasVeteranStatus =
                  (veteranStatus && veteranStatus !== 'Ineligible') ||
                  (coborrowerVeteranStatus && coborrowerVeteranStatus !== 'Ineligible');
                if (hasVeteranStatus) {
                  return null;
                }
                const hasAdvisorReferral = model.getIn(['loan', 'advisor']);
                if (hasAdvisorReferral) {
                  return null;
                }
                return model.getIn(['loan', 'visaValid']) ? null : 'ExpiringVisa';
              },
              continuation
            )
          )
        },
        ({ model }) => {
          return model.getIn(['loan', 'citizen']) ? null : 'NonCitizen';
        },
        Branch(
          {
            Alimony: Card(Alimony)
          },
          ({ model }) => {
            return model.getIn(['loan', 'paysAlimony']) ? 'Alimony' : null;
          },
          continuation
        )
      )
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/disqualifying.js